/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingcomingsoontitle3Inputs */

const en_crosspostingcomingsoontitle3 = /** @type {(inputs: Crosspostingcomingsoontitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming soon`)
};

const de_crosspostingcomingsoontitle3 = /** @type {(inputs: Crosspostingcomingsoontitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bald verfügbar`)
};

/**
* | output |
* | --- |
* | "Coming soon" |
*
* @param {Crosspostingcomingsoontitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingcomingsoontitle3 = /** @type {((inputs?: Crosspostingcomingsoontitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingcomingsoontitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingcomingsoontitle3(inputs)
	return de_crosspostingcomingsoontitle3(inputs)
});
export { crosspostingcomingsoontitle3 as "crosspostingComingSoonTitle" }